"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inviteToPromote = void 0;
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const constants_1 = require("../payloads/constants");
function inviteToPromote(options) {
  return tslib_1.__awaiter(this, void 0, void 0, function* () {
    const {
      inviteeAddress,
      role
    } = options || {};
    // adding address to the invitee map
    this.setSpaceSpecificData(oldData => {
      return (0, immer_1.produce)(oldData, draft => {
        if (draft.inviteeDetails) draft.inviteeDetails[inviteeAddress] = role;
      });
    });
    // we send a request to 'inviteeAddress' and try to add them to the mesh connection
    this.request({
      senderAddress: this.data.local.address,
      recipientAddress: inviteeAddress,
      chatId: this.spaceSpecificData.spaceId,
      details: {
        type: constants_1.SPACE_REQUEST_TYPE.INVITE_TO_PROMOTE,
        data: {
          role
        }
      }
    });
  });
}
exports.inviteToPromote = inviteToPromote;
//# sourceMappingURL=inviteToPromote.js.map